import { Column } from '@miq/catalog';
import { DataObject } from '@shared/models/data-object.model';
export interface ScoreDetails {
  totalScore?: number;
  errors: ScoreMessage[];
}
export interface ScoreMessage {
  error_code: string;
  fieldname: string;
  es_attribute_name: string;
  validation_type?: string;
  value?: string;
  rule_ref_value: string;
  columnId?: number;
  sectionId?: number;
  columnHeader?: string;
  inputType?: string;
  dataType?: string;
  format?: string;
  subtype?: string;
  entity?: string;
  isOverwrite?: boolean;
}
export enum QueueType {
  propertySync = 'propertySync',
  tim = 'timDataQuality',
  lease = 'leaseDataQuality',
  property = 'propertyDataQuality',
  availability = 'availabilityDataQuality',
  sale = 'saleDataQuality',
  company = 'companyDataQuality',
  contact = 'contactDataQuality',
}
export enum UpdateQueueEntity {
  leaseDataQuality = 'lease_data_quality',
  timDataQuality = 'tim_data_quality',
  propertyDataQuality = 'property_data_quality',
  availabilityDataQuality = 'availability_data_quality',
  saleDataQuality = 'sale_data_quality',
  companyDataQuality = 'company_data_quality',
  contactDataQuality = 'contact_data_quality',
}
export interface ScoresMap {
  [key: number]: { column: Column; error: ScoreMessage };
}
export interface QualityScoreData {
  errors: ScoreMessage[];
  qualityScores: string | DataObject[];
  isSubtypes: boolean;
}
